import { z } from 'zod';
import { GenericLegalTransactionRelationshipSchema } from '../../GenericLegalTransactionRelationshipSchema';
import { initLegalTransactionRelationshipSkeleton } from '../../ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../LegalTransactionRelationshipTypeEnum';
import { IMemberSigner, SignerMemberSchema } from '../../Members/IMemberSigner';
import {
  getEmptySignatureCertificationRelationshipData,
  SignatureCertificationDataSchema,
} from './ILegalTransactionRelationshipSignatureCertificationData';

export const SignatureCertificationRelationship =
  GenericLegalTransactionRelationshipSchema(
    z.literal(LegalTransactionRelationshipTypeEnum.SignatureCertification),
    z.literal(2).optional(),
    SignatureCertificationDataSchema,
    SignerMemberSchema
  );

export type ISignatureCertificationRelationship = Omit<
  z.infer<typeof SignatureCertificationRelationship>,
  'Members'
> & {
  Members: IMemberSigner[];
};

export function getEmptySignatureCertificationRelationship(): ISignatureCertificationRelationship {
  return {
    ...initLegalTransactionRelationshipSkeleton(),
    Version: 2,
    idRelationshipType:
      LegalTransactionRelationshipTypeEnum.SignatureCertification,
    data: getEmptySignatureCertificationRelationshipData(),
    Members: [],
  };
}
